export default __webpack_public_path__ + "static/media/IMG-20250105-WA0006.a25e623f.jpg";